<template :status="status">
    <div>
        <span class="label label-cyan" v-if="status === 'OPEN'">Open</span>
        <span class="label label-indigo" v-if="status === 'ACCEPTED'">Accepted</span>
        <span class="label label-grey text-white" v-if="status === 'CANCELLED'">Cancelled</span>
        <span class="label label-brown" v-if="status === 'SIGNED'">Signed</span>
        <span class="label label-orange" v-if="status === 'ESCROWED'">Escrowed</span>
        <span class="label label-orange" v-if="status === 'PAYMENT'">Payment</span>
        <span class="label label-ink" v-if="status === 'SCHEDULED'">Scheduled</span>
        <span class="label label-yellow" v-if="status === 'SHIPPED'">Shipped</span>
        <span class="label label-light-green" v-if="status === 'RELEASED'">Released</span>
        <span class="label label-dark-green" v-if="status === 'COMPLETE'">Complete</span>
    </div>
</template>

<script>
    export default {
        name: "TradeStatus",
        props: {
            status: {
                type: String,
                required: true
            }
        }
    }
</script>

<style scoped>

</style>